<script setup lang="ts">
  import type { User } from '@api/models';

  import type { AvatarVariants } from '@ui/components/avatar';

  import { UserAvatar } from '@/components/users';

  interface Props {
    assignee?: User | null;
    showAvatar?: boolean;
    showAvatarOnly?: boolean;
    size?: AvatarVariants['size'];
  }

  withDefaults(defineProps<Props>(), { size: 'sm' });
</script>

<template>
  <div class="flex items-center gap-x-3.5 text-xs truncate">
    <template v-if="assignee?.id">
      <UserAvatar v-if="showAvatar || showAvatarOnly" :user="assignee ?? undefined" :size="size" />

      <span v-if="!showAvatarOnly">
        {{ assignee.name }}
      </span>
    </template>

    <template v-else>
      <UserAvatar v-if="showAvatar || showAvatarOnly" :size="size" />
      <div v-if="!showAvatarOnly" class="text-muted-foreground">
        {{ 'No Assignee' }}
      </div>
    </template>
  </div>
</template>

<style scoped></style>
